<app-search-select
  [style]="style"
  [config]="config"
  [disabled]="disabled"
  [hideResetIcon]="hideResetIcon"
  [(selected)]="reassignSelected"
  [required]="true"
></app-search-select>
